import { render, staticRenderFns } from "./DisagreeChildSupport.vue?vue&type=template&id=d368f616"
import script from "./DisagreeChildSupport.vue?vue&type=script&lang=ts"
export * from "./DisagreeChildSupport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports